export default __webpack_public_path__ + "static/PROUD_sm-e64d2cafd8106bf4ae20fac89605636c.webp";